const RETURN_TO_KEY = 'returnTo'
// Not imported from routes.tsx: this util loads via axiosClient and would create an import cycle
const SKIPPED_PATHS = ['/', '/login', '/callback/backoffice_google_identity']

// Survives the same-tab Google login round-trip so deep links (e.g. MCP consent) are not lost
export function saveReturnTo(): void {
  const { pathname, search, hash } = window.location
  if (!SKIPPED_PATHS.includes(pathname)) {
    try {
      sessionStorage.setItem(RETURN_TO_KEY, pathname + search + hash)
    } catch {
      /* storage unavailable - the login redirect must still happen */
    }
  }
}

export function popReturnTo(): string {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY)
    sessionStorage.removeItem(RETURN_TO_KEY)
    return path && /^\/(?!\/|\\)/.test(path) ? path : '/'
  } catch {
    return '/'
  }
}
